import React from 'react';
import "./master-homework.scss";
import Header from '../common/header/header-component';
import Loading from '../common/loading/loading';
import CommonApi from '../../apis/common'
import SessionCache from '../routes/session-cache';
import Pagination from '../common/cw-pagination/cw-pagination-v2'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome, faSpinner, faDownload } from '@fortawesome/free-solid-svg-icons'
//import { faHome, } from '@fortawesome/free-solid-svg-icons'
import Path from '../routes/routes-path.js';
import Dropdown from '../common/dropdown/dropdown'
import DropdownV2 from '../common/dropdown-v2/dropdown'
import Utility from '../../utility/common-utilities';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import SchoolApi from '../../apis/school';
import HomeworkCompletedStudentList from './completed-homework/homework-completed-student-list';
import HomeworkApi from '../../apis/homework';
import { Constants, ImageConstants } from '../../constants/constants';
import { getImageSource } from '../../utility/image-source';
// import Utils from '../../constants/utils';
let { Parser } = require('json2csv');


class MasterSchoolwork extends React.Component {

    state = {
        meta: {},
        isLoading: false,
        payload: null,
        meta: { totalPages: 0, page: 1 },
        baseUrl: "",
        showCreateUserModal: false,
        selectedTab: "HOMEWORK",
        showFilters: true,
        boardsDropdownItems: [],
        classDropdownItems: [],
        sectionDropdownItems: [],
        selectedBoard: "",
        selectedClass: "",
        selectedSection: "",
        subjectId: '',
        reloadSubjectDropdown: false

    }

    tabs = [
        { name: "School Practice", value: "HOMEWORK" },
        { name: "School Assessments", value: "ASSESSMENT" },
        { name: "Self Practice", value: "HOMEWORK_SELF" },
        { name: "Self Assessments", value: "ASSESSMENT_SELF" },
        { name: "School Work Completed Student Summary", value: "STUDENTSUMMARY" },
        { name: "School Work Completed Student List", value: "STUDENTLIST" }
    ]

    schoolwork_type = [
        { title: 'Computer Lab Practice', value: "STANDARD_CLASSWORK" },
        { title: 'Personalised Practice', value: "ADAPTIVE_CLASSWORK" },
        { title: 'Clicker', value: "CLICKER" },

    ]

    assessment_type = [
        { title: 'Computer Lab Assessment', value: "NORMAL" },
        { title: 'Clicker', value: "CLICKER" },
    ]

    subjects_list = [
        { title: 'Maths', value: "66a9d13f933e00065a431f07" },
        { title: 'Science', value: "66a9d14e933e00065a431f08" },
    ]

    filter = {}

    currentPage = 1;
    pageLimit = 10
    mode = 'CREATE'
    selectedUser = {}

    ROLES = []

    constructor(props) {
        super(props)
        this.user = SessionCache.getUser();
        console.log(this.user)
        this.filter = { schoolId: this.user?.schoolInfo?.schoolCode }
    }

    componentDidMount() {
        this.getHomeworks()
        this.getSchoolBoardAndClasses()
    }



    onSchoolSearch(value) {
        if (value.length > 2 || !value) {
            this.getSchools({ name: value, }, false)
        }
    }


    getHomeworks(payload, isClear = false) {

        payload = this.buildPayload(payload)

        this.currentPage = payload.page || 1

        if (this.currentPage === 1) this.startIndex = 1

        if (this.state.subjectId) {
            payload.subjectId = this.state.subjectId
        }

        if (isClear) {
            payload.subjectId = ''
        }

        HomeworkApi.getHomeworksForMasterSchoolwork(payload).then((data) => {
            this.setState({
                meta: data.meta,
                totalUsers: data.meta.count,
                baseUrl: data.baseUrl,
                homeworkList: data.response,
                loading: false
            })
        }).catch((err) => {
            console.log(err)
        })

    }


    getHomeworkCompletedStudents(payload) {
        payload = this.buildHomeworkCompletedPayload(payload)

        this.currentPage = payload.page || 1
        if (this.currentPage === 1) this.startIndex = 1


        HomeworkApi.getHomeworkCompletedStudent(payload).then((data) => {
            // console.log(data);
            this.setState({
                meta: data.meta,
                totalUsers: data.meta.count,
                baseUrl: data.baseUrl,
                homeworkCompletedStudentList: data.response,
                loading: false
            })
        }).catch((err) => {
            console.log(err)
        })

    }

    getHomeworkCompletedStudentSummary(payload) {
        payload = this.buildHWCompletedStudentSummary(payload)

        this.currentPage = payload.page || 1
        if (this.currentPage === 1) this.startIndex = 1


        HomeworkApi.getHomeworkCompletedStudentSummary(payload).then((data) => {
            //console.log(data);
            this.setState({
                meta: data.meta,
                totalUsers: data.meta.count,
                baseUrl: data.baseUrl,
                homeworkCompletedStudentSummary: data.response,
                loading: false
            })
        }).catch((err) => {
            console.log(err)
        })
    }



    onClickTab(value) {

        if (value === "STUDENTLIST") {
            this.setState({ selectedTab: value, meta: {}, resetFilter: true, homeworkList: [] }, () => {
                this.filter = { page: 1, schoolId: this.user?.schoolInfo?.schoolCode }
                // this.getHomeworks({ ...this.filter })
                this.getSchoolBoardAndClasses()
                this.getHomeworkCompletedStudents({ ...this.filter })
                this.setState({ resetFilter: false })
            })
        } else if (value === "STUDENTSUMMARY") {
            this.setState({ selectedTab: value, meta: {}, resetFilter: true, homeworkList: [] }, () => {
                this.filter = { page: 1, schoolId: this.user?.schoolInfo?.schoolCode }
                // this.getHomeworks({ ...this.filter })
                this.getSchoolBoardAndClasses()
                this.getHomeworkCompletedStudentSummary({ ...this.filter })
                this.setState({ resetFilter: false })
            })
        } else {
            this.setState({ selectedTab: value, meta: {}, resetFilter: true, selectedSchool: '', reloadFilter: true }, () => {
                this.filter = { page: 1, schoolId: this.user?.schoolInfo?.schoolCode }
                this.getHomeworks({ ...this.filter })
                this.setState({ resetFilter: false, reloadFilter: false })
            })
        }
    }


    viewStudentDetail(student) {
        this.setState({ selectedTab: "STUDENTLIST", selectedUserId: student.userId, meta: {}, resetFilter: true, homeworkList: [] }, () => {
            this.filter = { page: 1 }
            this.onFilterGo()
            this.setState({ resetFilter: false })
        })
    }


    buildPayload(payload) {

        payload = { ...this.filter, type: this.state.selectedTab }
        if (!payload.limit) payload.limit = this.pageLimit
        if (!payload.page) payload.page = this.filter.page || this.currentPage
        return payload
    }

    buildHomeworkCompletedPayload(payload) {
        payload = { ...this.filter }
        if (!payload.limit) payload.limit = this.pageLimit
        if (!payload.page) payload.page = this.filter.page || this.currentPage
        return payload
    }

    buildHWCompletedStudentSummary(payload) {
        payload = { ...this.filter }
        if (!payload.limit) payload.limit = this.pageLimit
        if (!payload.page) payload.page = this.filter.page || this.currentPage
        return payload
    }

    onPageSelected = (selectedPage, startIndex) => {

        this.startIndex = startIndex
        this.filter.page = selectedPage

        if (this.state.selectedTab === "STUDENTLIST") {
            this.getHomeworkCompletedStudents(this.filter)
        } else if (this.state.selectedTab === 'STUDENTSUMMARY') {
            this.getHomeworkCompletedStudentSummary(this.filter)
        } else {
            this.getHomeworks(this.filter)
        }


    }

    goToHome = () => {
        this.props.history.push(Path.MENU)
    }

    getRegisterDate(date) {
        if (!date) return "-"
        let dateString = new Date(date).toISOString().split('T')[0]
        dateString = dateString.split("-").reverse().join("-")
        return dateString
    }

    toggleFilters = () => {
        this.setState({ showFilters: !this.state.showFilters })
    }

    handleCreatedDateEvent = (event, picker) => {
        this.createdDateRangeStart = new Date(picker.startDate);
        this.createdDateRangeEnd = new Date(picker.endDate).toLocaleDateString() == new Date().toLocaleDateString() ? new Date() : new Date(picker.endDate);

        this.setState({ createdDate: this.createdDateRangeStart.toLocaleDateString(), selectedCreatedDateRange: this.createdDateRangeStart.toLocaleDateString() + "  -  " + this.createdDateRangeEnd.toLocaleDateString() });
    }

    handleDueDateEvent = (event, picker) => {
        this.dueDateRangeStart = new Date(picker.startDate);
        this.dueDateRangeEnd = new Date(picker.endDate).toLocaleDateString() == new Date().toLocaleDateString() ? (new Date(new Date().setHours(23, 59, 59, 999)).toISOString()).slice(0, -1) : (new Date(new Date(picker.endDate).setHours(23, 59, 59, 999)).toISOString()).slice(0, -1);

        this.setState({ dueDate: new Date(this.dueDateRangeStart).toLocaleDateString(), selectedDueDateRange: new Date(this.dueDateRangeStart).toLocaleDateString() + "  -  " + new Date(this.dueDateRangeEnd).toLocaleDateString() });
    }

    onSelectSchool(option, key) {


        if (key === "homeworkList") {
            this.setState({ selectedSchool: option?.value })
        } else {

            this.setState({ selectedSchool: option?.value }, () => {
                console.log(this.state.selectedSchool)
                this.getSchoolBoardAndClasses()
            })
        }

    }


    onSelectDropDown = (option, key, cb) => {
        console.log(option, key)
        this.setState({ [key]: option?.value }, () => {
            if (key == "selectedClass" || key == "selectedBoard") {
                this.getSections()
            }
        })
    }

    onMultiSelectDropdown = (option, key) => {
        let value = [],
            options = option.sort((a, b) => a.order - b.order)
        for (let i = 0; i < options.length; i++) {
            let option = options[i]
            value.push(option?.value)
        }
        console.log(value)
        this.setState({ [key]: value })
    }


    getSchoolBoardAndClasses() {
        let payload = { schoolId: this.user?.schoolInfo?.schoolCode }
        SchoolApi.getClassAndBoard(payload).then(school => {
            let classes = [], boards = [];
            for (let i = 0; i < school.classes.length; i++) {
                classes.push({
                    title: school.classes[i].name,
                    value: school.classes[i].name,
                })
            }

            for (let i = 0; i < school.boards.length; i++) {
                boards.push({
                    title: school.boards[i].name,
                    value: school.boards[i].name,
                })
            }
            console.log(boards)

            // if (boards.length > 1) {
                this.setState({ boardsDropdownItems: boards })
            // } else {
            //     this.setState({ selectedBoard: boards[0]?.value}, () => {
            //     })
            // }

            this.setState({ classDropdownItems: classes })

        }).catch(err => {
        })



    }

    getSections(payload = {}) {
        if (!payload.schoolId) payload.schoolId = this.state.selectedSchool
        if (!payload.class) payload.class = this.state.selectedClass
        if (!payload.board) payload.board = this.state.selectedBoard

        if (!payload.class || !payload.board) {
            this.setState({ sectionDropdownItems: [], selectedSection: "" })
            return
        }

        console.log(payload)

        SchoolApi.getSections(payload)
            .then(response => {
                let sections = []
                console.log(response)
                for (let i = 0; i < response.response.length; i++) {
                    sections.push({
                        title: response.response[i].section,
                        value: response.response[i]._id,
                    })
                }
                console.log(sections)

                //this.classSectionHash[payload.class] = sections
                this.setState({ sectionDropdownItems: sections, selectedSection: "" })

            }).catch(err => {
                this.setState({ sectionDropdownItems: [], selectedSection: "" })

            })
    }





    onFilterGo(isClear) {
        this.setState({ meta: {} })
        let filter = { page: 1 }
        filter.schoolId = this.user?.schoolInfo?.schoolCode

        if (this.state.selectedSchoolworkType) {
            filter.selectedSchoolworkType = this.state.selectedSchoolworkType
        }

        if (this.state.selectedTab === "STUDENTLIST") {

            filter.schoolId = this.user?.schoolInfo?.schoolCode

            if (this.state.selectedSchool) {
                filter.schoolId = this.state.selectedSchool
            }

            if (this.state.selectedBoard) {
                filter.board = this.state.selectedBoard
            }

            if (this.state.selectedClass) {
                filter.class = this.state.selectedClass
            }

            console.log(this.state.selectedSection)

            if (this.state.selectedSection) {
                filter.sections = this.state.selectedSection
            }

            if (this.state.selectedUserId) {
                filter.userId = this.state.selectedUserId
            }

            if (this.state.selectedCompletedSchoolworkType) {
                filter.selectedCompletedSchoolworkType = this.state.selectedCompletedSchoolworkType
            }



            console.log(filter)
            if (isClear) {
                this.filter = {schoolId:this.user?.schoolInfo?.schoolCode}
                this.setState({
                    selectedSchool: null,
                    selectedBoard: null,
                    selectedClass: null,
                    selectedSection: null,
                    selectedUserId: '',
                    selectedCompletedSchoolworkType: '',
                    subjectId: null,
                    reloadFilter: true,
                    reloadSubjectDropdown: true,
                }, () => {
                    this.setState({ reloadFilter: false, reloadSubjectDropdown: false })
                })
                this.getHomeworkCompletedStudents({})
            } else {
                this.filter = { ...filter }
                this.getHomeworkCompletedStudents(filter)
            }

        } else if (this.state.selectedTab === 'STUDENTSUMMARY') {
            if (this.state.selectedUserId) {
                filter.userId = this.state.selectedUserId
            }

            if (this.state.selectedBoard) {
                filter.board = this.state.selectedBoard
            }

            if (this.state.selectedClass) {
                filter.class = this.state.selectedClass
            }

            filter.schoolId = this.user?.schoolInfo?.schoolCode

            // console.log(filter)
            if (isClear) {
                this.filter = {schoolId: this.user?.schoolInfo?.schoolCode}
                this.setState({
                    selectedSchool: null,
                    selectedBoard: null,
                    selectedClass: null,
                    selectedSection: null,
                    selectedUserId: '',
                    reloadFilter: true
                }, () => {
                    this.setState({ reloadFilter: false })
                })
                this.getHomeworkCompletedStudentSummary({})
            } else {
                this.filter = { ...filter }
                this.getHomeworkCompletedStudentSummary(filter)
            }
        }
        else {
            if (this.dueDateRangeStart) filter.dueDateRangeStart = this.dueDateRangeStart
            if (this.dueDateRangeEnd) filter.dueDateRangeEnd = (new Date(new Date(this.dueDateRangeEnd).setHours(23, 59, 59, 999)).toISOString()).slice(0, -1)
            if (this.createdDateRangeStart) filter.createdDateRangeStart = this.createdDateRangeStart
            if (this.createdDateRangeEnd) filter.createdDateRangeEnd = (new Date(new Date(this.createdDateRangeEnd).setHours(23, 59, 59, 999)).toISOString()).slice(0, -1)

            if (isClear) {
                this.filter = { schoolId: this.user?.schoolInfo?.schoolCode }
                this.dueDateRangeStart = ""
                this.dueDateRangeEnd = ""
                this.createdDateRangeStart = ""
                this.createdDateRangeEnd = ""
                this.setState({
                    dueDate: "",
                    selectedDueDateRange: "",
                    selectedCreatedDateRange: "",
                    createdDate: "",
                    selectedSchool: null,
                    reloadFilter: true,
                    selectedSchoolworkType: '',
                    subjectId: '',

                }, () => {
                    this.setState({ reloadFilter: false })
                })
                this.getHomeworks({}, true)
            } else {
                this.filter = { ...filter }
                this.getHomeworks(filter)
            }
        }

    }

    openHomeworkCompletedStudentListModal(homeworkId, seclectedSchoolId, schoolworkType, chapterTitle) {
        // console.log(homeworkId, seclectedSchoolId);
        this.setState({
            homeworkId: homeworkId, seclectedSchoolId: seclectedSchoolId, openStudentDetailModal: true,
            homeworkType: this.state.selectedTab, schoolworkType: schoolworkType, chapterTitle
        })
    }

    closeStudentDetailModal = () => {
        this.setState({ openStudentDetailModal: false })
    }


    onClickExport = () => {

        if (this.state.exporting) return

        this.setState({ exporting: true })
        console.log("Export")

        let payload = {
            type: this.state.selectedTab,
            ...this.filter
        }

        if(this.state.subjectId) {
            payload.subjectId  = this.state.subjectId
        }

        HomeworkApi.getCustomHomeworksForExport(payload).then((response) => {
            console.log(response.response)

            let serverResponse = response.response

            if (serverResponse) {

                let csvBuild = []
                for (let i = 0; i < serverResponse.length; i++) {
                    let item = serverResponse[i]

                    let obj = {
                    }
                    if (item["schoolId"]) {

                        if (item["school"]['name']) {
                            obj['SCHOOL NAME'] = item["school"]['name']
                        }

                        if (item["schoolId"]) {
                            obj['SCHOOL CODE'] = item["schoolId"]
                        }

                        if (item["subjectName"]) {
                            obj['Subject Name'] = item["subjectName"]
                        }

                        if (item["chapterTitle"]) {
                            obj['Chapter Name'] = item["chapterTitle"]
                        }

                        if (item["source"]) {
                            obj['source'] = item["source"]
                        }

                        if (item["isSynched"]) {
                            obj['Synched'] = item["isSynched"]
                        }

                        if (item["schoolAssessmentId"]) {
                            obj['Assignment Id'] = item["schoolAssessmentId"]
                        }

                        if (item["class"]) {
                            obj['CLASS'] = item["class"]
                        }

                        if (item["section"]) {
                            obj['SECTION'] = item["section"]
                        }

                        if (item["teacher"]['name']) {
                            obj['TEACHER NAME'] = item["teacher"]['name']
                        }

                        if (item?.createdDate || item.countingwellCreatedTimestamp) {
                            obj['ASSIGNED DATE'] = this.datePipe(item.createdDate || item.countingwellCreatedTimestamp)
                        }

                        if (item?.endDate) {
                            obj['DUE DATE'] = this.datePipe(item.endDate)
                        }

                        if (item["totalStudents"]) {
                            obj['ASSIGNED STUDENTS'] = item["totalStudents"]
                        }

                        if (item["completedStudents"]) {
                            obj['COMPLETED STUDENTS'] = item["completedStudents"]
                        }

                        if (item["accuracyPercentage"]) {
                            obj['Question Accuracy'] = item["accuracyPercentage"]
                        }

                        if (item["channel"]) {
                            obj['CHANNEL'] = item["channel"]
                        }

                        // if (item['type']) {
                        //     obj['TYPE'] = this.getName(item.type)
                        // }


                    }

                    csvBuild.push(obj)
                }
                let json2csvParser = new Parser();
                let csv = json2csvParser.parse(csvBuild);

                console.log(csv);

                let hiddenElement = document.createElement('a');
                hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
                hiddenElement.target = '_blank';
                hiddenElement.download = 'school_work_report_' + (new Date).toISOString() + '.csv';
                hiddenElement.click();
            }
            this.setState({ exporting: false })

        })
            .catch((err) => {
                this.setState({ exporting: false })
            });
    }

    datePipe(givenDate, isTime = true) {
        if (!givenDate) return "-"
        givenDate = new Date(givenDate).toString()
        const [day, month, date, year, time] = givenDate.split(' ')
        return `${date} ${month}, ${year} ${isTime ? time.substr(0, 5) : ""}`

    }


    onClickHomeworkCompletedStudentExport() {

        if (this.state.exporting) return

        this.setState({ exporting: true })
        console.log("Export")


        let payload = {
            page: 1,
            limit: 0,
            type: "HOMEWORK_COMPLETED_REPORT",
            ...this.filter
        }

        HomeworkApi.getHomeworkCompletedStudent(payload).then((data) => {
            console.log(data);
            this.setState({

                homeworkCompletedStudentListExport: data.response,

            })


            if (this.state.homeworkCompletedStudentListExport && this.state.homeworkCompletedStudentListExport.length > 0) {

                let homeworkCompletedStudentArray = this.state.homeworkCompletedStudentListExport

                console.log(homeworkCompletedStudentArray)

                let csvBuild = []
                for (let i = 0; i < homeworkCompletedStudentArray.length; i++) {
                    let item = homeworkCompletedStudentArray[i]

                    let obj = {
                    }
                    if (item["studentName"]) {

                        if (item['studentName']) {
                            obj['STUDENT NAME'] = item['studentName']
                        }
                        if (item['schoolName']) {
                            obj['SCHOOL NAME'] = item['schoolName']
                        }

                        if (item['schoolId']) {
                            obj['SCHOOL CODE'] = item['schoolId']
                        }

                        if (item["mobileNumber"]) {
                            obj['MOBILE NUMBER'] = item["mobileNumber"]
                        }

                        if (item["board"]) {
                            obj['BOARD'] = item["board"]
                        }

                        if (item["class"]) {
                            obj['CLASS'] = item["class"]
                        }

                        if (item["type"]) {
                            obj['TYPE'] = this.getName(item.type)
                        }


                        if (item["homeworkGivenChapterName"]) {
                            obj['SCHOOL WORK CHAPTER NAME'] = item["homeworkGivenChapterName"]
                        }

                        if (item?.homeworkCompletedTime) {
                            obj['SCHOOL WORK COMPLETED TIME'] = this.datePipe(item.homeworkCompletedTime)
                        }

                        if (item["homeworkNodeCount"]) {
                            obj['TOTAL ELO'] = item["homeworkNodeCount"]
                        }

                        if (item["totalNotClearedEloCount"]) {
                            obj['TOTAL NOT CLEARED ELO'] = item["totalNotClearedEloCount"]
                        }

                        if (item["gtOneAttemptedClearedELOCount"]) {
                            obj['ATTEMPTED ELO'] = item["gtOneAttemptedClearedELOCount"]
                        }

                        if (item["homeworkLearningCompletedPercentage"]) {
                            obj['LEARNING PERCENTAGE'] = item["homeworkLearningCompletedPercentage"]
                        }


                    }

                    csvBuild.push(obj)
                }
                let json2csvParser = new Parser();
                let csv = json2csvParser.parse(csvBuild);

                console.log(csv);

                let hiddenElement = document.createElement('a');
                hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
                hiddenElement.target = '_blank';
                hiddenElement.download = 'completed_student_report_' + (new Date).toISOString() + '.csv';
                hiddenElement.click();

                this.setState({ exporting: false })

            } else {
                this.setState({ exporting: false })
            }


        }).catch((err) => {
            console.log(err)
        })






    }

    onClickHomeworkCompletedStudentSummaryExport() {

        if (this.state.exporting) return

        this.setState({ exporting: true })
        console.log("Export")


        let payload = {
            page: 1,
            limit: 0,
            type: "HOMEWORK_COMPLETED_STUDENT_SUMMARY_REPORT"
        }

        if(this.state.subjectId) {
            payload.subjectId = this.state.subjectId
        }

        payload.schoolId = this.user?.schoolInfo?.schoolCode

        HomeworkApi.getHomeworkCompletedStudentSummary(payload).then((data) => {
            console.log(data);
            this.setState({

                homeworkCompletedStudentSummaryExport: data.response,

            })


            if (this.state.homeworkCompletedStudentSummaryExport && this.state.homeworkCompletedStudentSummaryExport.length > 0) {

                let homeworkCompletedStudentArray = this.state.homeworkCompletedStudentSummaryExport

                console.log(homeworkCompletedStudentArray)

                let csvBuild = []
                for (let i = 0; i < homeworkCompletedStudentArray.length; i++) {
                    let item = homeworkCompletedStudentArray[i]

                    let obj = {
                    }
                    if (item["studentName"]) {

                        if (item['studentName']) {
                            obj['STUDENT NAME'] = item['studentName']
                        }
                        if (item['schoolName']) {
                            obj['SCHOOL NAME'] = item['schoolName']
                        }

                        if (item['schoolId']) {
                            obj['SCHOOL CODE'] = item['schoolId']
                        }

                        if (item["mobileNumber"]) {
                            obj['MOBILE NUMBER'] = item["mobileNumber"]
                        }

                        if (item["board"]) {
                            obj['BOARD'] = item["board"]
                        }

                        if (item["class"]) {
                            obj['CLASS'] = item["class"]
                        }

                        if (item["completedHomeworkCount"]) {
                            obj['SCHOOL WORK COMPLETED COUNT'] = item["completedHomeworkCount"]
                        }



                        // if (item["homeworkNodeCount"]) {
                        //     obj['TOTAL ELO'] = item["homeworkNodeCount"]
                        // }

                        // if (item["totalNotClearedEloCount"]) {
                        //     obj['TOTAL NOT CLEARED ELO'] = item["totalNotClearedEloCount"]
                        // }

                        // if (item["gtOneAttemptedClearedELOCount"]) {
                        //     obj['ATTEMPTED ELO'] = item["gtOneAttemptedClearedELOCount"]
                        // }

                        // if (item["homeworkLearningCompletedPercentage"]) {
                        //     obj['LEARNING PERCENTAGE'] = item["homeworkLearningCompletedPercentage"]
                        // }


                    }

                    csvBuild.push(obj)
                }
                let json2csvParser = new Parser();
                let csv = json2csvParser.parse(csvBuild);

                console.log(csv);

                let hiddenElement = document.createElement('a');
                hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
                hiddenElement.target = '_blank';
                hiddenElement.download = 'completed_student_summary_report_' + (new Date).toISOString() + '.csv';
                hiddenElement.click();

                this.setState({ exporting: false })

            } else {
                this.setState({ exporting: false })
            }


        }).catch((err) => {
            console.log(err)
        })






    }


    getName(type) {
        if (type === 'STANDARD') {
            return 'Standard (H)'
        } else if (type === 'ADAPTIVE') {
            return 'Personalised (H)'
        } else if (type === 'STANDARD_CLASSWORK') {
            return 'Standard (C)'
        } else if (type === 'ADAPTIVE_CLASSWORK') {
            return 'Personalised (C)'
        } else if (type === 'NORMAL') {
            return 'Assessment (H)'
        } else if (type === 'CLASSWORK_ASSESSMENT') {
            return 'Assessment (C)'
        }

    }





    renderList() {
        return (

            <div className="row px-0">
                <div className="col">

                    <div>
                        <div className="pt-4">
                            <div className='d-flex justify-content-between'>
                                <div className="">
                                    <strong className="header-text">Assignment List</strong>
                                </div>
                                {/* <div className="col  my-auto  px-4">
                                    {this.state?.meta?.count ? <strong >Total: {this.state?.meta?.count || 0}</strong> : ""}
                                </div> */}
                                <div className=''>
                                    <span>
                                        {
                                            this.state.homeworkList && this.state.homeworkList.length > 0 ?
                                                <strong className="pr-1">
                                                    <span>{this.state?.meta?.count ? <strong >Total: {this.state?.meta?.count || 0}</strong> : ""}</span>
                                                    <button className='btn btn-primary btn-sm ml-4' onClick={() => { this.onClickExport() }}>
                                                        {
                                                            !this.state.exporting ? <span> <FontAwesomeIcon icon={faDownload} /> Export</span> :
                                                                <span>  <FontAwesomeIcon icon={faSpinner} spin />Exporting</span>
                                                        }
                                                    </button>
                                                </strong>
                                                : ""
                                        }
                                    </span>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="table-scoll" className="table-responsive pt-2">
                            <table className="table mb-0 align-items-center  bg-white">
                                <thead>
                                    <tr>
                                        {/* <th className='border-top-none'>School</th>
                                        <th className='border-top-none'>School Code</th> */}
                                        <th className='border-top-none'>Subject</th>
                                        <th className='border-top-none'>Chapter Name</th>
                                        <th className='border-top-none'>Source</th>
                                        <th className='border-top-none'>Synched</th>
                                        <th className='border-top-none'>Assignment Id</th>
                                        <th className='border-top-none'>Class</th>
                                        <th className='border-top-none'>Section</th>
                                        <th className='border-top-none'>Teacher</th>
                                        <th className='border-top-none'>Assigned Date</th>
                                        <th className='border-top-none'>Due Date</th>
                                        <th className='border-top-none'>Student Assigned</th>
                                        <th className='border-top-none'>Student Completed</th>
                                        <th className='border-top-none'>Question Accuracy</th>
                                        <th className='border-top-none'>Channel</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.homeworkList?.length ? this.state.homeworkList.map((item, index) => (

                                            <tr key={item._id}>
                                                {/* <td>{item.school?.name}</td>
                                                <td>{item.schoolId}</td> */}
                                                <td>{item.subjectName}</td>
                                                <td>{item.chapterTitle}</td>
                                                {/* <td>{this.getName(item.type)}</td> */}
                                                <td>{item.source}</td>
                                                <td>{item.isSynched}</td>
                                                <td>{item.schoolAssessmentId}</td>
                                                <td>{item.class}</td>
                                                <td>{item.section}</td>
                                                <td>{item.teacher?.name}</td>
                                                <td>{Utility.datePipe(item.createdDate, false)}</td>
                                                <td>{Utility.datePipe(item.endDate, false)}</td>
                                                <td>{item.totalStudents || 0}</td>
                                                <td className='student-count cursor-pointer' onClick={() => this.openHomeworkCompletedStudentListModal(item._id, item.schoolId, item.type, item.chapterTitle)} >{item.completedStudents || 0}</td>
                                                <td>{item.accuracyPercentage ? `${item.accuracyPercentage}%` : `0%`}</td>
                                                <td>{item.channel || "SCHOOL PORTAL"}</td>
                                            </tr>
                                        ))
                                            : <tr><td colSpan="10" align='center' className='text-gray'>No Records found !</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>

                    </div>

                </div>
            </div>
        )
    }

    getSubscribedTagColor(value = "") {

        // if (value.toLowerCase() === "subscribed") return "text-success"
        // if (value.toLowerCase() === "trial") return "text-warning"
        // return "text-danger"

        if (value.isSubscribed && value.subscriptionValidTill)
            return "text-success"
        else
            return "text-danger"

    }

    renderHomeworkCompletedStudentList() {
        return (

            <div className="row px-0">
                <div className="col">

                    <div>
                        <div className="pt-4">
                            <div className='d-flex justify-content-between'>
                                <div className="">
                                    <strong className="header-text">School Work Completed Student List</strong>
                                </div>
                                {/* <div className="col text-right my-auto px-4">
                                    {this.state?.meta?.count ? <strong >Total: {this.state?.meta?.count || 0}</strong> : ""}
                                </div> */}
                                <div className=''>
                                    <span>
                                        {
                                            this.state.homeworkCompletedStudentList && this.state.homeworkCompletedStudentList.length > 0 ?
                                                <strong className="pr-4">
                                                    <span>{this.state?.meta?.count ? <strong >Total: {this.state?.meta?.count || 0}</strong> : ""}</span>
                                                    <button className='btn btn-primary btn-sm ml-4' onClick={() => { this.onClickHomeworkCompletedStudentExport() }}>
                                                        {
                                                            !this.state.exporting ? <span> <FontAwesomeIcon icon={faDownload} /> Export</span> :
                                                                <span>  <FontAwesomeIcon icon={faSpinner} spin />Exporting</span>
                                                        }
                                                    </button>
                                                </strong>
                                                : ""
                                        }
                                    </span>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="table-scoll" className="table-responsive pt-2">
                            <table className="table mb-0 align-items-center  bg-white">
                                <thead>
                                    <tr>
                                        <th className='border-top-none'>Student Name</th>
                                        <th className='border-top-none'>School Name</th>
                                        <th className='border-top-none'>School Code</th>
                                        <th className='border-top-none'>Mobile Number</th>
                                        <th className='border-top-none'>Board</th>
                                        <th className='border-top-none'>Class</th><th className='border-top-none'>Plan</th>
                                        <th className='border-top-none'>Plan Expiry Date</th>
                                        <th className='border-top-none'>Source</th>
                                        <th className='border-top-none'>School Work Chapter Name</th>
                                        <th className='border-top-none'>School Work Completed Time</th>
                                        <th className='border-top-none'>Total ELO's</th>
                                        <th className='border-top-none'>Total Not Cleared ELO's</th>
                                        <th className='border-top-none'>Attempted ELO's</th>
                                        <th className='border-top-none'>Learning Percentage</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.homeworkCompletedStudentList?.length ? this.state.homeworkCompletedStudentList.map((item, index) => (

                                            <tr key={index}>
                                                <td>{item.studentName}</td>
                                                <td>{item.schoolName}</td>
                                                <td>{item.schoolId}</td>
                                                <td>{item.mobileNumber}</td>
                                                <td>{item.board}</td>
                                                <td>{item.class}</td>
                                                <td className={this.getSubscribedTagColor(item)}>{item.isSubscribed ? "PREMIUM" : "BASIC"}</td>
                                                <td>{item.subscriptionValidTill && item.isSubscribed ? Utility.datePipe(item.subscriptionValidTill, true) : '-'}</td>
                                                <td>{item.type}</td>
                                                <td>{item.homeworkGivenChapterName}</td>
                                                <td>{item.homeworkCompletedTime ? Utility.datePipe(item.homeworkCompletedTime, false) : "--"}</td>
                                                <td>{item.homeworkNodeCount}</td>
                                                <td>{item.totalNotClearedEloCount ? item.totalNotClearedEloCount : '-'}</td>
                                                <td>{item.gtOneAttemptedClearedELOCount ? item.gtOneAttemptedClearedELOCount : '-'}</td>

                                                <td>{item.homeworkLearningCompletedPercentage ? `${item.homeworkLearningCompletedPercentage}%` : '-'} </td>
                                            </tr>
                                        ))
                                            : <tr><td colSpan="10" align='center' className='text-gray'>No Records found !</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>

                    </div>

                </div>
            </div>
        )
    }

    renderHomeworkCompletedStudentSummary() {
        return (

            <div className="row px-0">
                <div className="col">

                    <div>
                        <div className="pt-4">
                            <div className='d-flex justify-content-between'>
                                <div className="">
                                    <strong className="header-text">School Work Completed Student Summary</strong>
                                </div>
                                {/* <div className="col text-right my-auto px-4">
                                    {this.state?.meta?.count ? <strong >Total: {this.state?.meta?.count || 0}</strong> : ""}
                                </div> */}
                                <div className=''>
                                    <span>
                                        {
                                            this.state.homeworkCompletedStudentSummary && this.state.homeworkCompletedStudentSummary.length > 0 ?
                                                <strong className="pr-4">
                                                    <span>{this.state?.meta?.count ? <strong >Total: {this.state?.meta?.count || 0}</strong> : ""}</span>
                                                    <button className='btn btn-primary btn-sm ml-4' onClick={() => { this.onClickHomeworkCompletedStudentSummaryExport() }}>
                                                        {
                                                            !this.state.exporting ? <span> <FontAwesomeIcon icon={faDownload} /> Export</span> :
                                                                <span>  <FontAwesomeIcon icon={faSpinner} spin />Exporting</span>
                                                        }
                                                    </button>
                                                </strong>
                                                : ""
                                        }
                                    </span>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="table-scoll" className="table-responsive pt-2">
                            <table className="table mb-0 align-items-center  bg-white">
                                <thead>
                                    <tr>
                                        <th className='border-top-none'>Student Name</th>
                                        <th className='border-top-none'>School Name</th>
                                        <th className='border-top-none'>School Code</th>
                                        <th className='border-top-none'>Mobile Number</th>
                                        <th className='border-top-none'>Board</th>
                                        <th className='border-top-none'>Class</th><th className='border-top-none'>Plan</th>
                                        <th className='border-top-none'>Plan Expiry Date</th>
                                        <th className='border-top-none'>School Work Completed Count</th>
                                        {/* <th className='border-top-none'>Homework Chapter Name</th>
                                        <th className='border-top-none'>Total ELO's</th>
                                        <th className='border-top-none'>Total Not Cleared ELO's</th>
                                        <th className='border-top-none'>Attempted ELO's</th>
                                        <th className='border-top-none'>Learning Percentage</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.homeworkCompletedStudentSummary?.length ? this.state.homeworkCompletedStudentSummary.map((item, index) => (

                                            <tr key={index}>
                                                <td>
                                                    <a href="javascript:void(0)" onClick={() => this.viewStudentDetail(item)}>
                                                        {item.studentName}
                                                    </a>
                                                </td>
                                                <td>{item.schoolName}</td>
                                                <td>{item.schoolId}</td>
                                                <td>{item.mobileNumber}</td>
                                                <td>{item.board}</td>
                                                <td>{item.class}</td>
                                                <td className={this.getSubscribedTagColor(item)}>{item.isSubscribed ? "PREMIUM" : "BASIC"}</td>
                                                <td>{item.subscriptionValidTill && item.isSubscribed ? Utility.datePipe(item.subscriptionValidTill, true) : '-'}</td>
                                                <td>{item.completedHomeworkCount}</td>
                                                {/* <td>{item.homeworkGivenChapterName}</td>
                                                <td>{item.homeworkNodeCount}</td>
                                                <td>{item.totalNotClearedEloCount ? item.totalNotClearedEloCount : '-'}</td>
                                                <td>{item.gtOneAttemptedClearedELOCount ? item.gtOneAttemptedClearedELOCount : '-'}</td>

                                                <td>{item.homeworkLearningCompletedPercentage ? `${item.homeworkLearningCompletedPercentage}%` : '-'} </td> */}
                                            </tr>
                                        ))
                                            : <tr><td colSpan="10" align='center' className='text-gray'>No Records found !</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>

                    </div>

                </div>
            </div>
        )
    }




    renderFilters() {
        return (

            <div className='filter'>
                <div className='filter-header'>
                    <div className='d-inline cursor-pointer' onClick={this.toggleFilters}>
                        <div className='filter-title d-inline'>{'Filters'}</div>
                        <div className='d-inline'>
                            <i
                                class={
                                    this.state.showFilters
                                        ? 'filter-arrow up'
                                        : 'filter-arrow down'
                                }
                            ></i>
                        </div>
                    </div>
                </div>
                {!this.state.reloadFilter ?
                    <div
                        className={
                            this.state.showFilters
                                ? 'filter-content pt-2 '
                                : 'filter-content d-none pt-2'
                        }
                    >
                        <div className="row">
                            {/* <div className='col-lg-3 col-md-6 col-sm-12 pt-4'>
                                <div className='filter-input-label'>Schools</div>
                                {
                                    !this.state.reloadDropdown ?
                                        <div className='action pr-1'>
                                            {
                                                <DropdownV2
                                                    key="School"
                                                    placeholder='Search School'
                                                    options={this.state.schoolDropdown}
                                                    onSelect={(option) => this.onSelectSchool(option, "homeworkList")}
                                                    text="title"
                                                    onSearch={(value) => this.onSchoolSearch(value)}
                                                    style={{ background: "white" }}
                                                >
                                                </DropdownV2>
                                            }
                                        </div> : ""
                                }
                            </div> */}

                            <div className='col-lg-3 col-md-6 col-sm-12 pt-4'>
                                <div className='filter-input-label'>Subjects</div>
                                {

                                    <div className='action pr-1'>
                                        {
                                            <DropdownV2
                                                placeholder='Select a Subject'
                                                options={this.subjects_list}
                                                onSelect={(option) => this.onSelectDropDown(option, "subjectId")}
                                                text={"title"}
                                                value={this.state.subjectId}
                                            >
                                            </DropdownV2>
                                        }

                                    </div>

                                }
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                <div className="filter-input-label">
                                    Due Date
                                </div>
                                <div>
                                    <DateRangePicker onHide={this.handleDueDateEvent} onCancel={() => { }}
                                        autoApply
                                        maxDate={new Date().toLocaleDateString()}
                                        initialSettings={{ singleDatePicker: false, startDate: this.dueDatesRangeStart, endDate: this.dueDateRangeEnd, autoUpdateInput: false }}
                                        locale={{
                                            'format': 'DD/MM/YYYY'
                                        }}

                                    ><input className="cw-input bg-white" placeholder="Select date" value={this.state.selectedDueDateRange}></input>
                                    </DateRangePicker>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                <div className="filter-input-label">
                                    Created Date
                                </div>
                                <div>
                                    <DateRangePicker onHide={this.handleCreatedDateEvent} onCancel={() => { }}
                                        autoApply
                                        maxDate={new Date().toLocaleDateString()}
                                        initialSettings={{ singleDatePicker: false, startDate: this.createdDatesRangeStart, endDate: this.createdDateRangeEnd, autoUpdateInput: false }}
                                        locale={{
                                            'format': 'DD/MM/YYYY'
                                        }}

                                    ><input className="cw-input bg-white" placeholder="Select date" value={this.state.selectedCreatedDateRange}></input>
                                    </DateRangePicker>
                                </div>
                            </div>
                            <div className='col-lg-3 col-md-6 col-sm-12 pt-4'>
                                <div className='filter-input-label'>School Work Type</div>
                                {
                                    !this.state.reloadDropdown ?
                                        <div className='action pr-1'>
                                            {
                                                <DropdownV2
                                                    placeholder='Select a type'
                                                    options={this.state.selectedTab === 'HOMEWORK' ? this.schoolwork_type : this.assessment_type}
                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedSchoolworkType")}
                                                    text={"title"}
                                                    value={this.state.selectedSchoolworkType}
                                                >
                                                </DropdownV2>
                                            }
                                        </div> : ""
                                }
                            </div>
                            <div className='col text-right my-auto'>
                                <div className='filter-button  d-inline-block'>
                                    <button className={`cw-button`} onClick={() => this.onFilterGo()}>
                                        {'GO'}
                                    </button>
                                </div>
                                <div className='filter-button d-inline-block ml-2'>
                                    <button
                                        className={`cw-button-secondary`}
                                        onClick={() => this.onFilterGo(true)}
                                    >
                                        Clear
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div> : ""}
            </div>


        )
    }

    renderHomeworkCompletedStudentFilters() {
        return (
            <div className='filter'>
                <div className='filter-header'>
                    <div className='d-inline' onClick={this.toggleFilters}>
                        <div className='filter-title d-inline'>{'Filters'}</div>
                        <div className='d-inline'>
                            <i
                                class={
                                    this.state.showFilters
                                        ? 'filter-arrow up'
                                        : 'filter-arrow down'
                                }
                            ></i>
                        </div>
                    </div>
                </div>
                {!this.state.reloadFilter ?
                    <div
                        className={
                            this.state.showFilters
                                ? 'filter-content pt-2 '
                                : 'filter-content d-none pt-2'
                        }
                    >
                        <div className="row">
                            {/* <div className='col-lg-3 col-md-6 col-sm-12 pt-4'>
                                <div className='filter-input-label'>Schools</div>
                                {
                                    !this.state.reloadDropdown ?
                                        <div className='action pr-1'>
                                            {
                                                <DropdownV2
                                                    key="School"
                                                    placeholder='Search School'
                                                    options={this.state.schoolDropdown}
                                                    onSelect={(option) => this.onSelectSchool(option, "studentList")}
                                                    text="title"
                                                    onSearch={(value) => this.onSchoolSearch(value)}
                                                    style={{ background: "white" }}
                                                >
                                                </DropdownV2>
                                            }
                                        </div> : ""
                                }
                            </div> */}
                            <div className='col-lg-3 col-md-6 col-sm-12 pt-4'>
                                <div className='filter-input-label'>Board</div>
                                {
                                    !this.state.reloadDropdown ?
                                        <div className='action pr-1'>
                                            {
                                                <DropdownV2
                                                    placeholder='Select a board'
                                                    options={this.state.boardsDropdownItems}
                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedBoard")}
                                                    text={"title"}
                                                    value={this.state.selectedBoard}
                                                >
                                                </DropdownV2>
                                            }
                                        </div> : ""
                                }
                            </div>
                            <div className='col-lg-3 col-md-6 col-sm-12 pt-4'>
                                <div className='filter-input-label'>Class</div>
                                {
                                    !this.state.reloadDropdown ?
                                        <div className='action pr-1'>
                                            {
                                                <DropdownV2
                                                    placeholder='Select a Class'
                                                    options={this.state.classDropdownItems}
                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedClass")}
                                                    text={"title"}
                                                    value={this.state.selectedClass}
                                                >
                                                </DropdownV2>
                                            }
                                        </div> : ""
                                }
                            </div>
                            <div className='col-lg-3 col-md-6 col-sm-12 pt-4'>
                                <div className='filter-input-label'>School Work Type</div>
                                {
                                    !this.state.reloadDropdown ?
                                        <div className='action pr-1'>
                                            {
                                                <DropdownV2
                                                    placeholder='Select a type'
                                                    options={this.schoolwork_type}
                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedCompletedSchoolworkType")}
                                                    text={"title"}
                                                    value={this.state.selectedSchoolworkType}
                                                >
                                                </DropdownV2>
                                            }
                                        </div> : ""
                                }
                            </div>
                            {/* <div className='col-lg-3 col-md-6 col-sm-12 pt-4'>
                                    <div className='filter-input-label'>Sections</div>
                                            {
                                                !this.state.reloadDropdown ?
                                                    <div className='action pr-1'>
                                                        {
                                                            <DropdownV2
                                                                key={"Section"}
                                                                multiSelect
                                                                placeholder='Select a Section'
                                                                options={this.state.sectionDropdownItems}
                                                                onSelect={(option) => this.onMultiSelectDropdown(option, "selectedSection")}
                                                                text={"title"}
                                                                value={this.state.selectedSection}
                                                            >
                                                            </DropdownV2>
                                                        }
                                                    </div> : ""
                                            }
                                </div> */}
                            <div className='col text-right mt-4'>
                                <div className='filter-button d-inline-block mr-2'>
                                    <button
                                        className={`cw-button-secondary`}
                                        onClick={() => this.onFilterGo(true)}
                                    >
                                        Clear
                                    </button>
                                </div>
                                <div className='filter-button  d-inline-block'>
                                    <button className={`cw-button`} onClick={() => this.onFilterGo()}>
                                        {'GO'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div> : ""}
            </div>

        )
    }

    renderHomeworkCompletedSummaryFilters() {
        return (
            <div className='filter'>
                <div className='filter-header'>
                    <div className='d-inline' onClick={this.toggleFilters}>
                        <div className='filter-title d-inline'>{'Filters'}</div>
                        <div className='d-inline'>
                            <i
                                class={
                                    this.state.showFilters
                                        ? 'filter-arrow up'
                                        : 'filter-arrow down'
                                }
                            ></i>
                        </div>
                    </div>
                </div>
                {!this.state.reloadFilter ?
                    <div
                        className={
                            this.state.showFilters
                                ? 'filter-content pt-2 '
                                : 'filter-content d-none pt-2'
                        }
                    >
                        <div className="row">
                            {/* <div className='col-lg-3 col-md-6 col-sm-12 pt-4'>
                                <div className='filter-input-label'>Schools</div>
                                {
                                    !this.state.reloadDropdown ?
                                        <div className='action pr-1'>
                                            {
                                                <DropdownV2
                                                    key="School"
                                                    placeholder='Search School'
                                                    options={this.state.schoolDropdown}
                                                    onSelect={(option) => this.onSelectSchool(option, "studentList")}
                                                    text="title"
                                                    onSearch={(value) => this.onSchoolSearch(value)}
                                                    style={{ background: "white" }}
                                                >
                                                </DropdownV2>
                                            }
                                        </div> : ""
                                }
                            </div> */}
                            <div className='col-lg-3 col-md-6 col-sm-12 pt-4'>
                                <div className='filter-input-label'>Board</div>
                                {
                                    !this.state.reloadBoardDropdown ?
                                        <div className='action pr-1'>
                                            {
                                                <DropdownV2
                                                    placeholder='Select a board'
                                                    options={this.state.boardsDropdownItems}
                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedBoard")}
                                                    text={"title"}
                                                    value={this.state.selectedBoard}
                                                >
                                                </DropdownV2>
                                            }
                                        </div> : ""
                                }
                            </div>
                            <div className='col-lg-3 col-md-6 col-sm-12 pt-4'>
                                <div className='filter-input-label'>Class</div>
                                {
                                    !this.state.reloadDropdown ?
                                        <div className='action pr-1'>
                                            {
                                                <DropdownV2
                                                    placeholder='Select a Class'
                                                    options={this.state.classDropdownItems}
                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedClass")}
                                                    text={"title"}
                                                    value={this.state.selectedClass}
                                                >
                                                </DropdownV2>
                                            }
                                        </div> : ""
                                }
                            </div>
                            {/* <div className='col-lg-3 col-md-6 col-sm-12 pt-4'>
                                    <div className='filter-input-label'>Sections</div>
                                            {
                                                !this.state.reloadDropdown ?
                                                    <div className='action pr-1'>
                                                        {
                                                            <DropdownV2
                                                                key={"Section"}
                                                                multiSelect
                                                                placeholder='Select a Section'
                                                                options={this.state.sectionDropdownItems}
                                                                onSelect={(option) => this.onMultiSelectDropdown(option, "selectedSection")}
                                                                text={"title"}
                                                                value={this.state.selectedSection}
                                                            >
                                                            </DropdownV2>
                                                        }
                                                    </div> : ""
                                            }
                                </div> */}
                            <div className='col text-right mt-4'>
                                <div className='filter-button d-inline-block mr-2'>
                                    <button
                                        className={`cw-button-secondary`}
                                        onClick={() => this.onFilterGo(true)}
                                    >
                                        Clear
                                    </button>
                                </div>
                                <div className='filter-button  d-inline-block'>
                                    <button className={`cw-button`} onClick={() => this.onFilterGo()}>
                                        {'GO'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div> : ""}
            </div>

        )
    }

    onClickBack() {
        return window.location.hash = '#/school/dashboard'
    }


    render() {

        return (
            <div>
                {this.state.isLoading && <Loading></Loading>}

                <div className="master-homework">
                    {this.state.showBackButton || Constants.ELECTRON_BUILD ? <img className='report-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={this.onClickBack} /> : ''}
                    <div className='header-title'>Activities</div>
                    <div className="row py-4">
                        <div className="col-12 my-auto">
                            <div className="row  pl-2">
                                {
                                    this.tabs.map(tab => (
                                        <div className={`tab text-center col-3 py-2 mr-1 ${this.state.selectedTab === tab.value ? "active-tab-1" : ""}`} onClick={() => this.onClickTab(tab.value)}>
                                            {tab.name}
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    {this.state.openStudentDetailModal ? <HomeworkCompletedStudentList show={this.state.openStudentDetailModal}
                        homeworkId={this.state.homeworkId}
                        homeworkType={this.state.homeworkType}
                        schoolId={this.state.seclectedSchoolId}
                        schoolworkType={this.state.schoolworkType}
                        chapterTitle={this.state.chapterTitle}
                        onClose={this.closeStudentDetailModal}>

                    </HomeworkCompletedStudentList> : ''}

                    <div>
                        {this.state.selectedTab === "STUDENTLIST" ? this.renderHomeworkCompletedStudentFilters() : ""}
                        {(this.state.selectedTab === "HOMEWORK" || this.state.selectedTab === 'HOMEWORK_SELF' ||
                            this.state.selectedTab === "ASSESSMENT" || this.state.selectedTab === 'ASSESSMENT_SELF') ? this.renderFilters() : ""}
                        {this.state.selectedTab === "STUDENTSUMMARY" ? this.renderHomeworkCompletedSummaryFilters() : ""}
                    </div>


                    <div className="pt-1">

                        {(this.state.selectedTab === "HOMEWORK" || this.state.selectedTab === 'HOMEWORK_SELF' ||
                            this.state.selectedTab === "ASSESSMENT" || this.state.selectedTab === 'ASSESSMENT_SELF') ? this.renderList() : ""}
                        {this.state.selectedTab === "STUDENTLIST" ? this.renderHomeworkCompletedStudentList() : ""}
                        {this.state.selectedTab === 'STUDENTSUMMARY' ? this.renderHomeworkCompletedStudentSummary() : ""}

                        <div className="text-right p-2">
                            {
                                this.state.meta.totalPages ?
                                    <Pagination selectedPage={this.currentPage} startIndex={this.startIndex} totalPages={this.state.meta.totalPages} onPageSelected={this.onPageSelected.bind(this)} ></Pagination>
                                    : ""
                            }
                        </div>
                    </div>

                </div>


            </div>
        );
    }

}

export default MasterSchoolwork;